import { Flex, Text } from '@chakra-ui/react';
import { Code } from 'constants/keyboard';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectPageCount, selectPageNumberStart } from 'modules/Editor/store/infographSelector';
import { setPageNumberStart } from 'modules/Editor/store/infographSlice';
import { Input } from 'modules/common/components/Input';
import { ChangeEvent, KeyboardEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { inputWidth, labelWidth } from '../PageNumberMenu.config';

const startPageNumberTestId = 'start-page-number';
const startPageNumberInputTestId = 'start-page-number-input';

export const StartPageNumber = () => {
  const pageCount = useAppSelector(selectPageCount);
  const pageNumberStart = useAppSelector(selectPageNumberStart);
  const dispatch = useAppDispatch();

  const [isValidPageNumberStart, setIsValidPageNumberStart] = useState(true);
  const [pageNumberStartInput, setPageNumberStartInput] = useState(pageNumberStart.toString());

  const inputId = 'custom-page-start';
  const { t } = useTranslation('common_navbar');
  const label = t('pageNumber.start-number-at');

  const onChangePageNumberStart = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value || '';
    // remove non-numeric characters
    const value = inputValue.replace(/\D/g, '');
    const isValid = Number(value) <= pageCount && Number(value) > 0;

    setPageNumberStartInput(value);
    setIsValidPageNumberStart(isValid);
  };

  const setPageNumberStartValue = () => {
    if (isValidPageNumberStart) {
      dispatch(setPageNumberStart(Number(pageNumberStartInput)));
    }
  };

  const onInputKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === Code.Enter) setPageNumberStartValue();
  };

  const onBlurInput = () => setPageNumberStartValue();

  return (
    <Flex gap={2} data-testid={startPageNumberTestId}>
      <Text fontSize='sm' w={labelWidth} as='label' htmlFor={inputId} fontWeight='medium'>
        {label}
      </Text>
      <Input
        w={inputWidth}
        size='xs'
        errorBorderColor='red.600'
        value={pageNumberStartInput}
        onChange={onChangePageNumberStart}
        isInvalid={!isValidPageNumberStart}
        onKeyDown={onInputKeyDown}
        onBlur={onBlurInput}
        cursor='text'
        id={inputId}
        data-testid={startPageNumberInputTestId}
        textAlign='right'
      />
    </Flex>
  );
};
